import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import CompareListPage from "@/pages/compare/page";
import CompareDetailPage from "@/pages/compare/detail/page";
import ArticleListPage from "@/pages/articles/page";
import ArticleDetailPage from "@/pages/articles/detail/page";
import AboutPage from "@/pages/about/page";
import FaqPage from "@/pages/faq/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/compare",
    element: <CompareListPage />,
  },
  {
    path: "/compare/:id",
    element: <CompareDetailPage />,
  },
  {
    path: "/articles",
    element: <ArticleListPage />,
  },
  {
    path: "/articles/:slug",
    element: <ArticleDetailPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/faq",
    element: <FaqPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;